import {LayoutContext} from "@components/Contexts/LayoutContext"
import YoutubePrivacyPolicyContent from "@components/Pages/YoutubePrivacyPolicy/YoutubePrivacyPolicyContent"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import youtubeIntegrationPolicyJSON from "@jsons/youtubeIntegrationPolicy.json"
import React, {useContext} from "react"

type Props = {}

const youtubePrivacyPolicy = (props: Props) => {
	const AdvancedSideAsset = getTranslatedPageData(
		youtubeIntegrationPolicyJSON,
		true,
		true,
	)
	const list = getValueOrThrow(AdvancedSideAsset.AdvancedSideAsset)

	const {changeLayout} = useContext(LayoutContext)
	changeLayout("private")

	return (
		<>
			<HeadMeta meta={AdvancedSideAsset.metaData} />
			<YoutubePrivacyPolicyContent data={getValueOrThrow(list?.[0])} />
		</>
	)
}

export default youtubePrivacyPolicy
